import { render, staticRenderFns } from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=template&id=a5a2a8ee&scoped=true&"
import script from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=style&index=0&id=a5a2a8ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a2a8ee",
  null
  
)

export default component.exports